import { TicketController } from "@lib/titan2-slingo/dist/game/controller/TicketController";
import { GameEvent } from "./event/GameEvent";
export class GameTicketController extends TicketController {
    updateDarkenedReelsRecovery() {
        super.updateDarkenedReelsRecovery();
        this.model.updateMatchedSymbolsFromDarkenedReels();
    }
    updateDarkenedReels() {
        // Unfortunately, joker indexes are not sent during replay spins, which means a manual check against fully dabbed columns is required.
        // Fortunately, darkening never occurs for super jokers, and can be trivially determined for jokers by checking if their column is fully dabbed.
        const darkenedReels = [];
        const symbols = this.model.getSpinResult().getReelSequence().getSymbols();
        for (const [column, symbol] of symbols.entries()) {
            if (symbol.isJoker() && this.model.columnFullyDabbed(column)) {
                darkenedReels.push(column);
            }
        }
        this.model.getReelDisplayData().setDarkenedReels(darkenedReels);
        this.model.updateMatchedSymbolsFromDarkenedReels();
    }
    handleDabSuccess() {
        const selectedCell = this.model.getDabData().getSelectedCell();
        this.model.addMatchedSymbolFromDab(selectedCell);
        super.handleDabSuccess();
    }
    handleAutoDabSuccess() {
        const autoDabIndex = this.model.getDabData().getAutoDabIndex();
        const autoDabCell = this.model.getDabData().getAutoDabCells()[autoDabIndex];
        this.model.addMatchedSymbolFromDab(autoDabCell);
        super.handleAutoDabSuccess();
    }
    async handleDabComplete() {
        await this.model.waitForTicketDabsInProgress();
        await this.dispatchBlockingEvent(GameEvent.AWARD_FREE_SPINS);
        super.handleDabComplete();
    }
}
//# sourceMappingURL=GameTicketController.js.map